import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import langEnum from "constants/langEnum.js";
import twitterAuthor from "constants/twitterAuthor.js";
import volumeIdEnum from "constants/volumeIdEnum.js";
import useAuthScript from "hooks/use-auth-scripts.js";

const Head = ({ data }) => {
  useAuthScript();

  return (
    <Helmet
      htmlAttributes={{
        lang: langEnum[data.siteId],
        id: data.htmlId || ""
      }}
      title={data.title}
      titleTemplate="%s"
      meta={[
        {
          name: "description",
          content: data.description
        },
        {
          property: "og:title",
          content: data.title
        },
        {
          property: "og:description",
          content: data.description
        },
        {
          property: "og:image",
          content:
            data.imageUrl ||
            (data.image ? volumeIdEnum[data.image.volumeId] + data.image.filename : "")
        },
        {
          property: "og:type",
          content: "website"
        },
        {
          name: "twitter:card",
          content: "summary"
        },
        {
          name: "twitter:creator",
          content: twitterAuthor
        }
      ].concat(data.meta || [])}
    >
      <script async="async" src="https://www.googletagservices.com/tag/js/gpt.js"></script>
      <script>{`
        var googletag = googletag || {};
        googletag.cmd = googletag.cmd || [];
        `}</script>
      {data.siteId === 9 && (
        <link
          href="https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,700&display=swap"
          rel="stylesheet"
        />
      )}
    </Helmet>
  );
};

Head.propTypes = {
  data: PropTypes.shape({
    siteId: PropTypes.number,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    image: PropTypes.object,
    imageUrl: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    adArray: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
};

export default Head;
